import axios from 'axios'
import { connect } from 'react-redux'
import BaseContainer from 'components/newsletters/BaseContainer'
import { infoMappingById } from 'services/infoMapping'
import { fileOverlayerSeen } from '../../actions/eventsAction'
import getDataAttributeToJON from 'services/getDataAttributeToJON'
import bodyScrollLock from 'services/bodyScrollLock'

const SUBSCRIPTION_SOURCE_ID = 'document-download-component'

class DocumentContainer extends BaseContainer {

  constructor(props) {
    super(props);
    this.componentName = `DocumentContainerNew-${this.props.elementIndex}`

    this.state.hide_component = true
    this.state.current_link = null
  }

  componentDidMount() {
    try {
      const textOptions = getDataAttributeToJON(this.props.mainId, 'content')
      this.textOptions = {}

      if (Object.keys(textOptions).length) {
        this.textOptions = {
          overlay_text: textOptions.text,
          overlay_title: textOptions.headline,
          button: textOptions.button,
          confirmation: textOptions.confirmation,
          placeholderEmail: textOptions.placeholderEmail
        }
      }
    } catch (e) {

    }

    this.transformDocuments()
    this.createSubscriptionElement()
    this.addDownloadHandler();
    this.handleAutomaticallyDownload()
  }

  autoDownload(url, fileName = url.split('/').reverse()[0]) {
    const link = document.createElement('a');
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  addDownloadHandler() {
    document.addEventListener('click', (event) => {
      const clickedElement = event.target;
      if (clickedElement.classList.contains('overlay-close') || clickedElement.classList.contains('modal-close') && this.state.current_link) {
        event.preventDefault();
        if (this.is_link_allowed()) {
          this.autoDownload(this.state.current_link)
          this.state.current_link = null;
        }
      }
    });

  }
  transformDocuments() {
    let documents = document.getElementsByClassName("react-signupwall"),
      index = 0,
      size = documents.length
    const modal = document.querySelector('#modal-popup-signup-wall-overlay')
    const closeElements = modal ? [modal.querySelector('.overlay-close'), modal.querySelector('.modal-close')] : null;

    if (!this.is_link_allowed()) {
      for (; index < size; index++) {
        if (window.location.href.indexOf('?file=') === -1) {
          documents[index].href = btoa(JSON.stringify({ href: documents[index].href }));
        }
        documents[index].dataset.identifier = index
        documents[index].onclick = event => { this.handleClick(event) }
      }
    }
  }

  handleAutomaticallyDownload() {
    if (window.location.href.indexOf('?file=') === -1) { return null; }
    const fileUrl = window.location.search.split('?file=')[1]

    if (!fileUrl && !fileUrl.length) { return null; }
    const fileName = fileUrl.split('/').reverse()[0]

    const docs = document.getElementsByClassName('react-signupwall')
    const len = docs.length
    let fileFullPath = null
    let i = 0

    for (; i < len; i++) {
      fileFullPath = docs[i].href

      if (docs[i].href.indexOf(fileName) !== -1) break;
    }

    if (fileFullPath === null) return;
    axios({
      url: fileFullPath,
      method: 'GET',
      responseType: 'blob',
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      this.autoDownload(url, fileName);
    })
  }

  handleClick(event) {
    let target = event.target;
    const modal = document.querySelector('#modal-popup-signup-wall-overlay')

    if (!target.classList.contains("react-signupwall")) {
      target = target.closest("a.react-signupwall")
    }

    this.props.fileOverlayerSeen()
    const encodedHref = target.getAttribute('href'),
      decoded = JSON.parse(atob(encodedHref));

    this.state.current_link = decoded.href;
    window.document_identifier = target.dataset.identifier
    if (this.props.view === this.state.view_types.doi) {
      target.setAttribute('href', decoded.href)
      return false;
    }

    event.preventDefault()

    if (!this.is_link_allowed()) {
      if (!window.finanztip) {
        window.finanztip = { disableBodyScroll: () => { } };
      }
      window.finanztip.documentUrl = encodedHref;
      window.finanztip.documentFileName = decoded.href;
      const modalHeading = modal.querySelector('.overlay-heading');
      const modalContent = modal.querySelector('.content');
      const modalText = modal.querySelector('.overlay-text');
      const dynamicInfo = this.mapDataParamsAndFileParams(decoded.href);

      modalHeading.innerHTML = dynamicInfo.overlay_title;
      modalText.innerHTML = dynamicInfo.overlay_text;

      modal.classList.add('active');
      bodyScrollLock.disableScroll(modal);
    }
  }

  mapDataParamsAndFileParams(href) {
    const mapped = infoMappingById(href)
    if (Object.keys(this.textOptions).length) {
      const options = this.textOptions

      return { ...mapped, ...options };
    }

    mapped.button = 'Jetzt anmelden'
    mapped.confirmation = mapped.confirmation || null
    mapped.placeholderEmail = null
    return mapped;
  }

  is_link_allowed() {
    return this.props.view === this.state.view_types.doi;
  }

  createSubscriptionElement() {
    let sourceElement = document.createElement('div'),
      body = document.getElementsByTagName('body')[0]

    sourceElement.setAttribute('data-subscription-source', 'document-download')
    sourceElement.setAttribute('id', SUBSCRIPTION_SOURCE_ID)

    body.appendChild(sourceElement)
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state) => ({
  view: state.view
})

export default connect(mapStateToProps, { fileOverlayerSeen })(DocumentContainer)
